import React from "react";
import { InputText } from "primereact/inputtext";
import "./TowerObservationTypeActionForm.scss";
export const TowerObservationTypeForm = (props) => {
  return (
    <div className="tower-equip-form">
      <div className="p-grid">
        <div className="p-col-6">
          <div className="p-grid">
            <div className="p-col-3">
              <div className="form-field-container">
                <label>Código</label>
                <InputText value={props.record.oid} onChange={props.changeHandler} disabled={true} />
              </div>
            </div>

            <div className="p-col-12 form-field-container">
              <label className="lxRequiredField">Nome</label>
              <InputText value={props.record.name} onChange={props.changeHandler} name="name" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
